// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const TeamMemberDetails = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const member = location.state?.member;

//   if (!member) {
//     return <div style={{ padding: '2rem', color: '#000' }}>No team member data provided.</div>;
//   }

//   return (
//     <div style={styles.container}>
//       <div style={styles.imageContainer}>
//         <img src={member.image} alt={member.name} style={styles.image} />
//       </div>

//       <div style={styles.textContainer}>
//         <h1 style={styles.position}>{member.position?.toUpperCase() || 'EMPLOYEE'}</h1>
//         <h2 style={styles.name}>{member.name?.toUpperCase()}</h2>
//         <p style={styles.about}>{member.about || 'No description available.'}</p>
//       </div>

//       <button style={styles.button} onClick={() => navigate(-1)}>← Back</button>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     background: 'rgba(255, 255, 255, 0.1)',
//     // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//     minHeight: '100vh',
//     padding: '2rem',
//     textAlign: 'center',
//     color: '#2c2c2c',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   imageContainer: {
//     width: '220px',
//     height: '220px',
//     overflow: 'hidden',
//     borderRadius: '50%',
//     marginBottom: '1rem',
//     boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
//     backgroundColor:"red"
//   },
//   image: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'contain',
//   },
//   textContainer: {
//     maxWidth: '600px',
//   },
//   position: {
//     fontSize: '3rem',
//     fontWeight: 'bold',
//     color: '#F37021',
//     marginBottom: '0.2rem',
//   },
//   name: {
//     fontSize: '1.8rem',
//     fontWeight: '600',
//     color: '#0A1733',
//     marginBottom: '0.8rem',
//     textDecoration: 'underline', letterSpacing: '5px' ,
//     textUnderlineOffset: '6px', // Space between text and underline
//     textDecorationThickness: '2px'
//   },
//   about: {
//     fontSize: '1rem',
//     color: '#555',
//     padding: '0 1rem',
//     lineHeight: 1.6,
    
//   },
//   button: {
//     marginTop: '2rem',
//     padding: '0.7rem 1.5rem',
//     backgroundColor: '#F37021',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//   },
// };

// export default TeamMemberDetails;


// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import backgroundImage from '../Images/12365115.png'; // ✅ Adjust the path if needed

// const TeamMemberDetails = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const member = location.state?.member;

//   if (!member) {
//     return <div style={{ padding: '2rem', color: '#000' }}>No team member data provided.</div>;
//   }

//   return (
//     <div style={{ ...styles.container, backgroundImage: `url(${backgroundImage})` }}>
//       <div style={styles.overlay}>
//         <div style={styles.imageContainer}>
//           <img src={member.image} alt={member.name} style={styles.image} />
//         </div>

//         <div style={styles.textContainer}>
//           <h1 style={styles.position}>{member.position?.toUpperCase() || 'EMPLOYEE'}</h1>
//           <h2 style={styles.name}>{member.name}</h2>
//           <p style={styles.about}>{member.about || 'No description available.'}</p>
//         </div>

//         <button style={styles.button} onClick={() => navigate(-1)}>← Back</button>
//       </div>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     backgroundRepeat: 'no-repeat',
//     minHeight: '100vh',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     padding: '2rem',
//   },
//   overlay: {
//     backgroundColor: 'rgba(255, 255, 255, 0.85)',
//     padding: '3rem',
//     borderRadius: '20px',
//     boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
//     textAlign: 'center',
//     maxWidth: '700px',
//     width: '100%',
//   },
//   imageContainer: {
//     width: '200px',
//     height: '200px',
//     overflow: 'hidden',
//     borderRadius: '50%',
//     margin: '0 auto 1rem',
//     boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
//   },
//   image: {
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//   },
//   textContainer: {
//     marginTop: '1rem',
//   },
//   position: {
//     fontSize: '2.5rem',
//     fontWeight: 'bold',
//     color: '#a4511f',
//     marginBottom: '0.5rem',
//   },
//   name: {
//     fontSize: '1.6rem',
//     fontWeight: '600',
//     color: '#333',
//     marginBottom: '1rem',
//   },
//   about: {
//     fontSize: '1rem',
//     color: '#555',
//     lineHeight: 1.6,
//     padding: '0 1rem',
//   },
//   button: {
//     marginTop: '2rem',
//     padding: '0.7rem 1.5rem',
//     backgroundColor: '#a4511f',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//   },
// };

// export default TeamMemberDetails;

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TeamMemberDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const member = location.state?.member;

  if (!member) {
    return <div style={{ padding: '2rem', color: '#000' }}>No team member data provided.</div>;
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.left}>
          <div style={styles.imageWrapper}>
            <img src={member.image} alt={member.name} style={styles.image} />
          </div>
        </div>
        <div style={styles.right}>
          <h1 style={styles.position}>{member.position?.toUpperCase() || 'EMPLOYEE'}</h1>
          <h2 style={styles.name}>{member.name?.toUpperCase()}</h2>
          <hr style={styles.divider} />
          <p style={styles.about}>{member.about || 'No description available.'}</p>
          <button style={styles.button} onClick={() => navigate(-1)}>← Back</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: '100vh',
    padding: '4rem 2rem',
    backgroundColor: '#f8f8f8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    maxWidth: '1000px',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: '3rem',
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '16px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
    flexWrap: 'wrap',
  },
  left: {
    flex: '1 1 280px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageWrapper: {
    width: '240px',
    height: '240px',
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: '#F37021',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  right: {
    flex: '2 1 500px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  position: {
    fontSize: '2rem',
    fontWeight: '700',
    color: '#F37021',
    marginBottom: '0.2rem',
    letterSpacing: '1px',
  },
  name: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#0A1733',
    textDecoration: 'underline',
    letterSpacing: '4px',
    textUnderlineOffset: '6px',
    textDecorationThickness: '2px',
    marginBottom: '0.8rem',
  },
  divider: {
    border: 'none',
    borderTop: '2px solid #ccc',
    margin: '1rem 0',
    width: '100%',
  },
  about: {
    fontSize: '1rem',
    color: '#444',
    lineHeight: 1.6,
    marginBottom: '2rem',
  },
  button: {
    padding: '0.6rem 1.4rem',
    backgroundColor: '#F37021',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    transition: 'all 0.3s ease',
  },
};

export default TeamMemberDetails;
